module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "RobotoCondensed-Regular.d585f5c7.ttf";